<template>
  <div class="navigation-editor">
    <el-form ref="form" :model="form" :label-width="isEn() ? '180px' : '180px'" label-position="left">
      <el-form-item prop="backgroundColor" :label="$t('microSite.navigation.label.backgroundColor')">
        <el-color-picker v-model="form.backgroundColor"></el-color-picker>
        <span class="color-text">{{ form.backgroundColor }}</span>
      </el-form-item>
      <el-form-item prop="textColor" :label="$t('microSite.navigation.label.textColor')">
        <el-color-picker v-model="form.textColor"></el-color-picker>
        <span class="color-text">{{ form.textColor }}</span>
      </el-form-item>
      <el-form-item prop="activeColor" :label="$t('microSite.navigation.label.activeColor')">
        <el-color-picker v-model="form.activeColor"></el-color-picker>
        <span class="color-text">{{ form.activeColor }}</span>
      </el-form-item>
      <!-- <el-form-item prop="hoverColor" :label="$t('microSite.navigation.label.hoverColor')">
        <el-color-picker v-model="form.hoverColor"></el-color-picker>
        <span class="color-text">{{ form.hoverColor }}</span>
      </el-form-item> -->
      <el-form-item prop="btnColor" :label="$t('microSite.navigation.label.btnColor')">
        <el-color-picker v-model="form.btnColor"></el-color-picker>
        <span class="color-text">{{ form.btnColor }}</span>
      </el-form-item>
      <el-form-item class="size-config" :label="$t('microSite.common.label.size.width')">
        <SwitchButton v-model="form.size.width.type" :options="sizeOptions.width"></SwitchButton>
        <el-slider
          v-if="form.size.width.type === SIZE_TYPE.SCREEN_PERCENTAGE"
          v-model="form.size.width.percentage"
          show-input
          :min="1"
          :max="100"
        ></el-slider>
        <el-input
          v-if="form.size.width.type === SIZE_TYPE.FIXED"
          v-model="form.size.width.fixed"
          type="number"
        >
          <template #append>px</template>
        </el-input>
      </el-form-item>
      <el-form-item class="size-config" :label="$t('microSite.common.label.size.height')">
        <SwitchButton v-model="form.size.height.type" :options="sizeOptions.height"></SwitchButton>
        <el-slider
          v-if="form.size.height.type === SIZE_TYPE.SCREEN_PERCENTAGE"
          v-model="form.size.height.percentage"
          show-input
          :min="1"
          :max="100"
        ></el-slider>
        <el-input
          v-if="form.size.height.type === SIZE_TYPE.FIXED"
          v-model="form.size.height.fixed"
          type="number"
        >
          <template #append>px</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('microSite.navigation.label.link')">
        <div class="navigation-editor-menu" >
          <el-button @click="openAddOuterMenu">{{ $t('microSite.navigation.btn.addExternalLink') }}</el-button>
          <el-button @click="openAddInnerMenu">{{ $t('microSite.navigation.btn.addInnerLink') }}</el-button>
          <div v-if="showInnerLinkForm" class="navigation-editor-popover">
            <div class="navigation-editor-item">
              <div class="navigation-editor-item-left">
                <el-select
                  v-model="selectedPageId"
                  :placeholder="$t('microSite.navigation.placeholder.selectInnerPage')"
                  @change="handlePageChange"
                >
                  <el-option
                    v-for="(item, index) in sitePages"
                    :key="index"
                    :label="item.metaInfo.title"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-select v-model="selectedModuleId" clearable :placeholder="$t('microSite.navigation.placeholder.selectInnerLink')">
                  <el-option
                    v-for="(item, index) in pageModules"
                    :key="index"
                    :label="item.label"
                    :value="item.value.id"
                  ></el-option>
                </el-select>
                <el-checkbox v-model="editor.formData.openInNewWindow">{{ $t('microSite.navigation.openInNewTab') }}</el-checkbox>
              </div>
              <div>
                <el-button @click="handleCancel">{{ $t('common.btn.cancel') }}</el-button>
                <el-button type="primary" @click="handleConfirm">{{ $t('common.btn.ok') }}</el-button>
              </div>
            </div>
          </div>
          <div v-if="showOuterLinkForm" class="navigation-editor-popover">
            <div class="navigation-editor-item">
              <el-input v-model="editor.formData.label" :placeholder="$t('microSite.navigation.placeholder.linkName')"></el-input>
            </div>
            <div class="navigation-editor-item">
              <el-input v-model="editor.formData.path" :placeholder="$t('microSite.navigation.placeholder.linkUrl')"></el-input>
            </div>
            <div class="navigation-editor-item">
              <div class="navigation-editor-item-left">
                <el-checkbox v-model="editor.formData.openInNewWindow">{{ $t('microSite.navigation.openInNewTab') }}</el-checkbox>
              </div>
              <div>
                <el-button @click="handleCancel">{{ $t('common.btn.cancel') }}</el-button>
                <el-button type="primary" @click="handleConfirm">{{ $t('common.btn.ok') }}</el-button>
              </div>
            </div>
          </div>
        </div>
        <draggable v-model="form.menus">
          <div class="navigation-editor-menu" v-for="(item, index) in form.menus" :key="index">
            <div class="navigation-editor-menu-button">
              <i class="el-icon-sort"></i>
            </div>
            <div class="navigation-editor-menu-title">{{ item.label }}</div>
            <div class="navigation-editor-menu-title">{{ item.path }}</div>
            <div class="navigation-editor-menu-button" @click="editMenu(item)">
              <i class="el-icon-edit"></i>
            </div>
            <div class="navigation-editor-menu-button" @click="deleteMenu(index)">
              <i class="el-icon-delete"></i>
            </div>
          </div>
        </draggable>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import { isEn } from '@/i18n'
import Module from './index'
import editorTemplate from '../editorTemplate'
import { SIZE_TYPE } from '../renderMixin'
import SwitchButton from '../../components/editor/switchButton.vue'

export default {
  components: {
    draggable,
    SwitchButton
  },
  mixins: [editorTemplate],
  data () {
    return {
      isEn,
      form: {
        backgroundColor: null,
        textColor: null,
        activeColor: null,
        hoverColor: null,
        btnColor: null,
        menus: [],
        size: {
          width: {
            type: SIZE_TYPE.FIXED,
            fixed: null,
            percentage: null
          },
          height: {
            type: SIZE_TYPE.AUTO,
            fixed: null,
            percentage: null
          }
        }
      },
      showInnerLinkForm: false,
      showOuterLinkForm: false,
      pageModules: [],
      selectedPageId: null,
      selectedModuleId: null,
      editor: {
        isEditMode: false,
        menuItem: {},
        formData: {}
      },
      menuItemTemplate: {
        label: '',
        path: '',
        isInner: true,
        isOnboardingPage: false,
        openInNewWindow: false,
        isSatisfactionSurveyPage: false
      }
    }
  },
  computed: {
    ...mapGetters('microSite', ['sitePages']),
    selectedPage: {
      get () {
        return _.find(this.sitePages, { id: this.selectedPageId })
      },
      set (pageData) {
        this.selectedPageId = pageData && pageData.id
      }
    },
    selectedModule: {
      get  () {
        return _.find(this.pageModules, { value: { id: this.selectedModuleId } })
      },
      set (moduleData) {
        this.selectedModuleId = moduleData && moduleData.value.id
      }
    }
  },
  created () {
    const props = this.renderData.data.props
    this.form.menus = props.menus ? _.cloneDeep(props.menus) : []
    this.form.backgroundColor = props.backgroundColor || '#ffffff'
    this.form.textColor = props.textColor || '#909399'
    this.form.activeColor = props.activeColor || (this.isMobile ? null : '#0096cc')
    this.form.hoverColor = props.hoverColor || '#303133'
    this.form.btnColor = props.btnColor || '#000000'
    const size = props.size
    this.form.size = {
      width: {
        type: size?.width?.type || (this.isMobile ? SIZE_TYPE.SCREEN_PERCENTAGE : SIZE_TYPE.FIXED),
        fixed: size?.width?.fixed || (this.isMobile ? 375 : 1366),
        percentage: size?.width?.percentage || 100
      },
      height: {
        type: size?.height?.type || SIZE_TYPE.AUTO,
        fixed: size?.height?.fixed || 60,
        percentage: size?.height?.percentage || 10
      }
    }
  },
  methods: {
    validateAndUpdateRenderData () {
      let result = false
      this.$refs.form.validate(valid => { result = valid })
      if (!result) {
        return result
      }
      const props = this.renderData.data.props
      props.menus = _.cloneDeep(this.form.menus)
      props.backgroundColor = this.form.backgroundColor
      props.textColor = this.form.textColor
      props.activeColor = this.form.activeColor
      props.hoverColor = this.form.hoverColor
      props.btnColor = this.form.btnColor
      const size = this.form.size
      this.$set(props, 'size', {
        width: {
          type: size.width.type,
          fixed: this.parseToInt(size.width.fixed),
          percentage: this.parseToInt(size.width.percentage)
        },
        height: {
          type: size.height.type,
          fixed: this.parseToInt(size.height.fixed),
          percentage: this.parseToInt(size.height.percentage)
        }
      })

      this.updateConfigInRoot()
      return true
    },
    deleteMenu (index) {
      this.form.menus.splice(index, 1)
    },
    openAddOuterMenu () {
      this.editor.menuItem = _.cloneDeep(this.menuItemTemplate)
      this.editor.menuItem.isInner = false
      this.editor.formData = _.cloneDeep(this.editor.menuItem)
      this.editor.isEditMode = false
      this.showInnerLinkForm = false
      this.showOuterLinkForm = true
    },
    openAddInnerMenu () {
      this.editor.menuItem = _.cloneDeep(this.menuItemTemplate)
      this.editor.menuItem.isInner = true
      this.editor.formData = _.cloneDeep(this.editor.menuItem)
      this.editor.isEditMode = false
      this.showOuterLinkForm = false
      this.showInnerLinkForm = true
    },
    handleCancel () {
      this.showOuterLinkForm = false
      this.showInnerLinkForm = false
      this.selectedPage = null
      this.selectedModule = null
    },
    handleConfirm () {
      if (this.editor.menuItem.isInner) {
        let pagePath = this.selectedPage.path
        const selectedPagePath = pagePath
        let label = null
        if (this.selectedModule) {
          const moduleId = this.selectedModule.value.id
          if (pagePath.includes('?')) {
            pagePath += `&scrollin=${moduleId}`
          } else {
            pagePath += `?scrollin=${moduleId}`
          }
          label = this.selectedModule.label
        } else {
          label = this.selectedPage.metaInfo.title
        }
        this.editor.formData.path = pagePath
        this.editor.formData.label = label
        this.editor.formData.isOnboardingPage = selectedPagePath === '/v/onboarding/questionnaire'
        this.editor.formData.isSatisfactionSurveyPage = _.includes([
          '/v/satisfaction-survey/questionnaire',
          '/v/candidate-portal/questionnaire'
        ], selectedPagePath)
      }
      const menuItem = this.editor.menuItem
      const formData = this.editor.formData
      menuItem.label = formData.label
      menuItem.path = formData.path
      menuItem.openInNewWindow = formData.openInNewWindow
      menuItem.isOnboardingPage = formData.isOnboardingPage || false
      menuItem.isSatisfactionSurveyPage = formData.isSatisfactionSurveyPage || false
      if (!this.editor.isEditMode) {
        this.form.menus.push(menuItem)
      }
      this.showInnerLinkForm = false
      this.showOuterLinkForm = false
    },
    editMenu (menuItem) {
      this.editor.menuItem = menuItem
      this.editor.formData = _.cloneDeep(menuItem)
      if (menuItem.isInner) {
        const pathParts = menuItem.path.split('?')
        const path = pathParts[0]
        let moduleId = -1
        if (pathParts.length > 1) {
          const params = pathParts[1].split('&')
          _.forEach(params, item => {
            if (item.includes('scrollin')) {
              const keyValue = item.split('=')
              moduleId = keyValue.length > 1 ? keyValue[1] : -1
              moduleId = parseInt(moduleId)
              return false
            }
          })
        }
        this.selectedPage = _.find(this.sitePages, { path })
        this.handlePageChange()
        if (moduleId > -1) {
          this.selectedModule = _.find(this.pageModules, { value: { id: moduleId } })
        }
      }

      this.editor.isEditMode = true
      this.showInnerLinkForm = menuItem.isInner
      this.showOuterLinkForm = !menuItem.isInner
    },
    handlePageChange (pageData) {
      const modules = require('../index')
      this.pageModules = _.chain(this.selectedPage.renderData.children)
        .filter(child => !child.skipMatch && child.tag !== Module.name)
        .map(child => ({
          label: child.data.props.title || modules.getProjectItemTitle(child),
          value: child
        }))
        .value()
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation-editor {
  min-height: 200px;
  word-break: break-word;

  &-menu {
    display: flex;
    &-title {
      flex: 1;
      margin-left: 20px;
    }
    &-button {
      cursor: pointer;
      margin-left: 5px;
      i {
        font-size: 18px;
      }
    }
  }
  &-popover {
    display: flex;
    position: absolute;
    background: white;
    flex-direction: column;
    width: 100%;
  }
  &-item {
    flex: 1;
    flex-direction: row;
    margin-bottom: 10px;
    display: flex;
    &-left {
      flex: 1;

      .el-select {
        + .el-select {
          width: calc(50% - 15px);
          margin: 0 10px;
        }
      }
    }
  }
  .el-color-picker {
    vertical-align: middle;
  }
  .color-text {
    margin-left: 15px;
    vertical-align: middle;
  }
  .size-config {
    .el-slider {
      margin-top: 15px;
    }
    .el-input {
      margin-top: 15px;
      ::v-deep {
        .el-input__inner[type="number"] {
          appearance: textfield;
          &::-webkit-inner-spin-button {
            appearance: none;
          }
        }
      }
    }
  }
}
</style>
